import { LazyMotion } from 'framer-motion';
import { Config } from './config';

async function loadFeatures() {
  const { default: features } = await import('./dom-animation');

  return features;
}

export const LightLazyMotion = ({ children }: React.PropsWithChildren) => (
  <Config>
    <LazyMotion strict features={loadFeatures}>
      {children}
    </LazyMotion>
  </Config>
);
